import { StageDetailViewDataService } from './shared/stage-detail-view.data.service';
import { StageDetailViewFormService } from './shared/stage-detail-view.form.service';
import { Component, Input, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import {
  BaseControl,
  ConfirmComponent,
  Microproceso,
  Tarea,
  TramiteBasico,
  Const,
} from '@app/shared';
import { AuthenticationService, Logger } from '@app/core';
import { StageDetailViewConfigService } from './shared/stage-detail-view.config.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ActividadDeault } from '@app/shared';
import { HelperFlowService } from '@app/shared/services/helper-flow.service';
import { NotifierService } from '@app/shared/services/notifier.service';
import { SelectTramiteComponent } from '@app/shared/select-tramite/select-tramite.component';
import { ProcessAutomationComponent } from '@app/administration/process-automation/process-automation.component';


// Define las acciones posibles para una tarea o actividad
type actionManage = 'select' | 'run';

export interface InfoStageDetailView {
  id: number;
  actividad?: string;
  actividad_id?: number;
  tarea?: string;
  tarea_id?: number;
  fin: boolean;
  delete: boolean;
  update: boolean;
}

const log = new Logger('StageDetailViewComponent');



@Component({
  selector: 'iw-stage-detail-view',
  templateUrl: './stage-detail-view.component.html',
  styleUrls: ['./stage-detail-view.component.scss'],
  providers: [
    StageDetailViewFormService,
    StageDetailViewDataService,
    HelperFlowService,
    NotifierService,
  ]
})
export class StageDetailViewComponent implements OnInit {
  // Define cuando mostrar el ghostBox
  ghostBox = true;
  // Define cuando se esta cargando un flujo
  isLoadingFlow = false;
  // Flujo actual consultado
  flow: TramiteBasico | Microproceso;
  // Historial de consulta del tramite seleccionado
  historyFlow: Array<number> = [];
  // Define cuando mostrar la tabla principal o el formulario
  formDetailOpen = false;
  // Contiene el id  seleccionado
  @Input() idTramiteSelect = -1;
  // Contiene el id la etapa seleccionada
  @Input() idEtapaSelect = -1;
  //
  @Input() stcRef: SelectTramiteComponent;
  // Define la accion a realizar en el formulario
  actionForm = '';
  // Pregunta de la modal de confirmaciones
  question = '';
  // Define si el rol en accion es para editar o agregar
  rolEdit = true;
  // Define los tipos de permisos que tiene el usuario en sesión
  activateAction = {
    created: false,
    review: false,
    update: false,
    delete: false,
  };
  // contiene la informacion de las etapas
  source: InfoStageDetailView[];
  // Configuracion de la tabla
  settings = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // contiene la informacion de las etapas

  // Contiene la informacion de la etapa seleccionada
  stageViewSelect: any;
  // Contiene la tarea Seleccionada
  taskSelect: Partial<Tarea>;
  // Contiene la tarea cargada
  taskLoaded: Partial<Tarea>;
  // Contiene la actividad Seleccionada
  activitySelect: Partial<ActividadDeault>;
  // Contiene la actividad Seleccionada
  activityAsTarea: Partial<Tarea>;
  // Contiene el id de la actividad Seleccionada
  idActivitySelect: number;
  // Contiene el id de la tarea Seleccionada
  idTaskSelect: number;
  // Muesta u oculta el flow
  viewFlow: boolean;
  // Muestra el titulo del flow
  configFlowTitle: boolean;

  controls: BaseControl<any>[] = [];
  // Indica si se debe mostrar el mensaje de error de la tarea
  showTaskError = false;
  // Suscripción a las notificaciones de otros componentes
  private notifications: Subscription;
  // Evento de salida que notifica ala padre para actualizar las etapas
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  // Referencia al componente de confirmación
  @ViewChild('confirm') private confirm: ConfirmComponent;
  // Referencia al componente del proceso
  @ViewChild('iwProcessAutomation') iwProcessAutomation: ProcessAutomationComponent;

  constructor(
    private toastr: ToastrService,
    private sdvfs: StageDetailViewFormService,
    private sdvds: StageDetailViewDataService,
    private hfs: HelperFlowService,
    private ns: NotifierService,
    private as: AuthenticationService
  ) { }

  ngOnInit() {
    // determina los permisos del usuario en sesions
    this.activateAction.created = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.created,
    );
    this.activateAction.review = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.review,
    );
    this.activateAction.update = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.update,
    );
    this.activateAction.delete = this.as.confirmPermission(
      Const.types_permissions.administracionEtapas,
      Const.types_action_permissions.delete,
    );

    const configTable = new StageDetailViewConfigService;
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      log.debug(res.action, res.data);
      // Asignasion de valores para accion guardar tarea
      this.idTaskSelect = res.data.tarea_id;
      this.idActivitySelect = res.id;
      // Asignasion de valores para accion guardar actividad
      this.idActivitySelect = res.data.actividad_id

      this.defineActionCondictions(res.action, res.data);
    });
    this.loadingStageDetailView();
    this.notifications = this.ns.get().subscribe(async (n: any) => {
      // Definir la acción que se quiere hacer con la tarea
      let action: actionManage;
      // Si se ejecutó el evento click en una tarea
      if (n.source === 'task') {
        switch (n.action) {
          case 'selectTask':
            action = 'select';
            this.showTaskError = false;
            this.taskSelect = n.data.task;
            this.idTaskSelect = n.data.task.id;
            this.taskLoaded = n.data.task;
            this.activityAsTarea = null;
            this.activitySelect = null;
            this.idActivitySelect = null;
            this.historyFlow = [];
            this.viewFlow = false;
            this.isLoadingFlow = false;
            this.flow = null;
            this.configFlowTitle = null;
            this.ghostBox = false;
            this.iwProcessAutomation.toggleCompletionMode(false);
            break;
          case 'runMicroProcess':
            action = 'run';
            break;
        }
      } else if (n.source === 'activity') {
        switch (n.action) {
          case 'selectActivity':
            action = 'select';
            this.showTaskError = false;
            this.activitySelect = n.data.activity;
            this.idActivitySelect = n.data.activity.id;
            this.taskSelect = null;
            this.taskLoaded = null;
            this.activityToTask();
            this.idTaskSelect = null;
            this.historyFlow = [];
            this.viewFlow = false;
            this.isLoadingFlow = false;
            this.flow = null;
            this.configFlowTitle = null;
            this.ghostBox = false;
            this.iwProcessAutomation.toggleCompletionMode(false);
            break;
        }
      }
    });
  }

  activityToTask() {
    log.debug(`activitySelect= ${this.activitySelect.tareas}`);
    const activityT = {
      activo: false,
      descripcion: this.activitySelect.descripcion,
      fecha_registro: null,
      id: this.activitySelect.id,
      meta: null,
      nombre: this.activitySelect.nombre,
      orden: this.activitySelect.orden,
      rechazable: null,
      tarea_actividad: this.activitySelect.id,
      tarea_forma: null,

    } as Partial<Tarea>;
    this.activityAsTarea = activityT;
  }

  loadingStageDetailView() {
    this.source = [];
    if (this.activateAction.review) {
      this.sdvds.getStageDetailView(this.idEtapaSelect).subscribe(
        stagesDetailView => {
          log.debug(stagesDetailView);
          stagesDetailView.forEach(sdetailv => {
            this.source.push({
              id: sdetailv.id,
              actividad: sdetailv.actividad ? sdetailv.actividad.nombre : null,
              actividad_id: sdetailv.actividad ? sdetailv.actividad.id : null,
              tarea: sdetailv.tarea ? sdetailv.tarea.nombre : null,
              tarea_id: sdetailv.tarea ? sdetailv.tarea.id : null,
              fin: sdetailv.fin,
              delete: this.activateAction.delete,
              update: this.activateAction.update
            });
            this.sourceData = new LocalDataSource(this.source);
          });
        });
    } else {
      this.toastr.error(
        'Usted no posee permisos para ver el detalle de las etapas del tramite',
        'Permiso denegado'
      );
    }
  }

  async defineActionCondictions(action: 'add' | 'update' | 'delete' = 'add', data?: any) {
    switch (action.toString()) {
      case 'add':
        if (this.activateAction.created) {
          this.ghostBox = true;
          this.activitySelect = null;
          this.activityAsTarea = null;
          this.taskLoaded = null;
          this.taskSelect = null;
          this.formDetailOpen = true;
          this.rolEdit = false;
          this.actionForm = 'Agregar';
          this.flow = null;
          this.stageViewSelect = true;
          this.controls = this.sdvfs.getFormStageDetailView(data);
        } else {

          this.toastr.error(
            'Usted no posee permisos para agregar detalles de las etapas en el sistema',
            'Permiso denegado'
          );
        }
        break;
      case 'update':
        if (this.activateAction.update) {
          if (data.tarea_id) {
            this.taskLoaded = await this.sdvds.getTask(data.tarea_id);
            this.taskSelect = this.taskLoaded;
            this.activitySelect = null;
            this.activityAsTarea = null;
          } else if (this.idActivitySelect) { // Se cambia el valor de verificación de data.actividad_id por el valor asignado a idActiviti select
            this.activitySelect = await this.sdvds.getActivity(this.idActivitySelect);
            this.activityToTask();
            this.taskSelect = null;
          }
          this.flow = null;
          this.formDetailOpen = true;
          this.rolEdit = true;
          this.actionForm = 'Modificar';
          this.stageViewSelect = data;
          this.ghostBox = false;
          this.controls = this.sdvfs.getFormStageDetailView(data);
        } else {
          this.toastr.error(
            'Usted no posee permisos para modificar detalles de las etapas en el sistema',
            'Permiso denegado'
          );
        }
        break;
      case 'delete':
        if (this.activateAction.delete) {
          this.stageViewSelect = data;
          this.question = '¿Realmente desea eliminar el detalle de la etapa?';
          this.confirm.open();
        } else {
          this.toastr.error(
            'Usted no posee permisos para eliminar el detalle de las etapas en el sistema',
            'Permiso denegado'
          );
        }
        break;
    }
  }

  sended(data: any) {
    if (data) {
      if(!this.idTaskSelect && !this.idActivitySelect) {
        this.showTaskError = true;
        return;
      }

      let stageDetailView: any;
      stageDetailView = {
        etapa_tramite: this.idEtapaSelect,
        actividad: this.idActivitySelect,
        tarea: this.idTaskSelect,
        fin: data.txtFin
      };
      if (this.rolEdit) {
        log.debug(this.stageViewSelect.id);
        this.sdvds.updateStageDetailView(this.stageViewSelect.id, stageDetailView).then(() => {
          this.loadingStageDetailView();
          this.closeFormStage();
        }).catch(() => {
          this.closeFormStage();
        });
      } else {
        this.sdvds.addStageDetailView(stageDetailView).then(() => {
          this.loadingStageDetailView();
          this.closeFormStage();
        }).catch(() => {
          this.closeFormStage();
        });
      }
    }
  }


  /**
   * Cierra el formulario o reinicia el componente a la tabla principal
   *
   * @memberof StageDetailViewComponent
   */
  closeFormStage() {
    this.actionForm = '';
    this.question = '';
    this.formDetailOpen = false;
    this.stageViewSelect = null;
    this.ghostBox = true;
    this.taskLoaded = null;
    this.showTaskError = false;
    this.taskSelect = null;
    this.idTaskSelect = null;
    this.activitySelect = null;
    this.idActivitySelect = null;
  }

  /**
   * Cierra el formulario o reinicia el componente a la tabla principal
   *
   * @memberof StageDetailViewComponent
   */
  closeFormStageView() {
    this.actionForm = '';
    this.question = '';
    this.close.emit();
    this.stageViewSelect = null;
    this.idTramiteSelect = null;
    this.idEtapaSelect = null;
    this.taskSelect = null;
    this.idTaskSelect = null;
    this.activitySelect = null;
    this.idActivitySelect = null;
    this.ghostBox = true;
    this.taskLoaded = null;
  }

  /**
   * Controla la respuesta del modal de confirmaciones
   *
   * @param {boolean} res
   * @memberof TramitStagesComponent
   */
  actionComfirm(res: boolean) {
    if (res) {
      this.deleteStageViewDetail();
    }
    this.question = '';
  }


  /**
   * Elimina un inforamacion adicional de una etapa
   *
   * @private
   * @memberof TramitStagesComponent
   */
  private deleteStageViewDetail() {
    this.sdvds.deleteStageDetailView(this.stageViewSelect.id).then(() => {
      this.loadingStageDetailView();
      this.closeFormStage();
    }).catch(() => {
      this.closeFormStage();
    });
  }
  loadFlow() {
    this.iwProcessAutomation.flowMode = 'etapas';
    this.iwProcessAutomation.selectedDefaultTramite();
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/time-control/tramit-stages/stage-detail-view/stage-detail-view.component.ts